import request from '@/utils/request'

// 所属模块
export function getModel(project_id) {
  return request({
    url: `common/get-by-project-model?project_id=${project_id}`,
    method: 'get'
  })
}

// 缺陷 影响版本、 http://120.237.80.132:8083/api/task/addTaskSelect?pv_id/111/task_id/1
export function getPversionList(data) {
  return request({
    url: `task/addTaskSelect`,
    method: 'get',
    params: data
  })
}

// 获取解决版本
export function getPsvList(pv_id_future, project_id) {
  return request({
    url: `task/addTaskSelect?pv_id_future=${pv_id_future}&project_id=${project_id}`,
    method: 'get'
  })
}

// 获取相关任务列表
export function getTaskList(demand_id) {
  return request({
    url: `task/addTaskSelect?demand_id=${demand_id}`,
    method: 'get'
  })
}

// 获取相关需求列表
export function getDemandList(pm_id) {
  return request({
    url: `task/addTaskSelect?pm_id=${pm_id}`,
    method: 'get'
  })
}

// 查看相关需求
export function seeAboutDemand(demand_id) {
  return request({
    url: `task/getTaskDemand?demand_id=${demand_id}`,
    method: 'get'
  })
}

// 获取左上角产品列表  common/get-by-user-project
export function getUserProjectList(user_id) {
  return request({
    url: `common/get-by-user-project?user_id=${user_id}`,
    method: 'get'
  })
}

// 模糊查询 根据用户名获取用户列表
export function getUserInfoByName(params) {
  return request({
    url: '/user/get/page',
    method: 'get',
    params: { state: 1, ...params }
  })
}

// 获取所属版本

export function getVersion(user_id) {
  return request({
    url: `demand/get-by-user-version?user_id=${user_id}`,
    method: 'get'
  })
}

// 取消关联需求 --公共  查看关联和取消观来你需求
// 取消关联需求提交
export function submitDisAssociated(pv_id, demand_ids, user_id, remark) {
  return request({
    url: 'version/cancel-relate-demand',
    method: 'post',
    data: {
      pv_id: pv_id,
      demand_ids: demand_ids,
      user_id: user_id,
      remark: remark
    }
  })
}

// 查看添加备注 common/create-log
export function submitNote(add) {
  return request({
    url: 'common/create-log',
    method: 'post',
    data: add
  })
}

// 根据id查询需求
export function getEditDemand(demand_id, system_code) {
  return request({
    url: `demand/get-by-id-demand?demand_id=${demand_id}&system_code=${system_code}`,
    method: 'get'
  })
}
